import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { CardHeader } from 'reactstrap';
import CheckBoxListItem from './CheckBoxListItem';

const useStyles = makeStyles({
    root: {
        minWidth: 200,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    header: {
        textAlign: 'center',
    },
});

const Permanencia = ({ stateless }) => {
    const classes = useStyles();

    return (
        <Card className={classes.root}>
            <CardHeader className={classes.header}>Permanência</CardHeader>
            <CardContent>
                <CheckBoxListItem items={['Todos', 'Permanente', 'Não Permanente']} name={'permanencia'} stateless={stateless} />
            </CardContent>
        </Card>
    );
};

export default Permanencia;
